import styled from 'styled-components'

import { media } from '../../../../../../utils/style-utils'

export const ButtonsWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;

  ${media.touch`
    display: none;
  `}
`
